import { combineReducers } from "@reduxjs/toolkit";
import coachMe from "./coachMe";
import me from "./me";

export const reducers = combineReducers({ coachMe, me });
